/* eslint-disable no-unused-vars */
import { getState, setState, removeState } from "@/utils/localStore";
import { LocalStoreConstants } from "@/utils/AppConfig";
import { UPDATE_PRIVACY_CONSENT, SET_PRIVACY_CONSENT, SET_PRIVACY_CONSENT_FIELD  } from "@/state/actions-mutations-type";

const state = {
    privacyConsent: {}
};

export const actions = {

    initStore({ state, commit }) {
        commit(SET_PRIVACY_CONSENT, getState(LocalStoreConstants.cookiePolicy));
    },
    [UPDATE_PRIVACY_CONSENT]({ state, commit }, data) {
        commit(SET_PRIVACY_CONSENT, data);
    }

};

export const mutations = {
    [SET_PRIVACY_CONSENT](state, data) {
        Object.assign(state.privacyConsent, data);
        setState(LocalStoreConstants.cookiePolicy, data);
    },
    [SET_PRIVACY_CONSENT_FIELD](state, data) {
        Object.assign(state.privacyConsent, { [data.key]: data.value });
        setState(LocalStoreConstants.cookiePolicy, state.privacyConsent);
    }
};

const getters = {
    privacyConsent(state) {
        return state.privacyConsent;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
